import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <>
      <div className="contact-cnt">
        <div className="contact-heading-wrapper">
          <h1 className="contact-heading">Contact Us</h1>
          <div className="contact-sub-heading">
            psum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
            tempor
          </div>
        </div>
        <div className="form-wrapper">
          <div className="form-input">
            <div className="input-name-cnt input">
              Name
              <input className="input-name "></input>
            </div>
            <div className="email-cnt input ">
              Email
              <input  className="input-name " ></input>
            </div>
            <div className="phone-cnt input">
            Phone
              <input  className="input-name "></input>
             
            </div>
            <div className="phone-cnt  input">
                Service
              <input  className="input-name " ></input>
            </div>
            <div className="message-cnt input">
              Message
              <input className="message" ></input>
            </div>
          </div>
        </div>
        <div className="sent-btn">
            Send
        </div>
      </div>
    </>
  );
};

export default Contact;
